// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.75 11C10.75 10.3096 11.3096 9.75 12 9.75C12.6904 9.75 13.25 10.3096 13.25 11C13.25 11.6904 12.6904 12.25 12 12.25C11.3096 12.25 10.75 11.6904 10.75 11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.2878 2.91444L12.0003 0.931641L6.71289 2.91444L7.41514 4.78709L8.00034 4.56764V5H5V17H7V23H17V17H19V5H16.0003V4.56764L16.5855 4.78709L17.2878 2.91444ZM11 20V17H13V20H11ZM12 7.75C13.7949 7.75 15.25 9.20507 15.25 11C15.25 12.7949 13.7949 14.25 12 14.25C10.2051 14.25 8.75 12.7949 8.75 11C8.75 9.20507 10.2051 7.75 12 7.75Z"}}]};

const TowerClockFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tower-clock-filled',
    ref,
    icon: element,
  },
));

TowerClockFilledIcon.displayName = 'TowerClockFilledIcon';

export default TowerClockFilledIcon;
